//----------------| Ecommerce Module |------------------//

import { blogData } from "./data";

const state = {
   blogData
}


// getters
const getters = {
   blogData: state => {
      return state.blogData;
   }
}

// actions
const actions = {

}

// mutations
const mutations = {

}

export default {
   state,
   getters,
   actions,
   mutations
}
